<img class="ap-logo" src="assets/images/logos/logo-ups-ap.svg" alt="UPS Access Point">
<span class="ap-tagline" [innerHTML]="'ship.shipUps.accessPoint.banner.tagline' | translate"></span>
